module.exports = __webpack_public_path__ + "teqbahn-assets/media/2.6a098d61.jpg";